module.exports = __webpack_public_path__ + "img/36.52b7d848.jpg";